'use strict';
var FooterController = /** @class */ (function () {
    /*@ngInject*/
    function FooterController(NavbarService, googleAnalytic) {
        var _this = this;
        this.date = new Date();
        NavbarService.getSupportKey()
            .then(function (response) {
            _this.supportKey = response.supportKey;
        });
        this.GoogleAnalyticsService = googleAnalytic;
    }
    FooterController.prototype.fireEvent = function (eventName) {
        this.GoogleAnalyticsService.sendEvent(eventName, 'click', '', 1);
    };
    return FooterController;
}());
export default FooterController;
//# sourceMappingURL=footer.component.js.map